import React from 'react';
import { List, Button, Popconfirm, Empty, Spin } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import DoctorCard from './DoctorCard';

const AssociatedDoctorsList = ({ doctors, loading, onRemove }) => {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!doctors || doctors.length === 0) {
    return (
      <Empty
        description="No doctors associated with this partner yet"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        style={{ padding: 40 }}
      />
    );
  }

  return (
    <List
      grid={{
        gutter: 16,
        xs: 1,
        sm: 2,
        md: 2,
        lg: 3,
        xl: 4,
        xxl: 4,
      }}
      dataSource={doctors}
      renderItem={(doctor) => (
        <List.Item>
          <DoctorCard
            doctor={doctor}
            actions={[
              <Popconfirm
                key="remove"
                title="Remove Doctor"
                description="Are you sure you want to dissociate this doctor from the partner?"
                onConfirm={() => onRemove?.(doctor.id)}
                okText="Yes"
                cancelText="No"
                okButtonProps={{ danger: true }}
              >
                <Button
                  type="link"
                  danger
                  icon={<DeleteOutlined />}
                  size="small"
                >
                  Remove
                </Button>
              </Popconfirm>,
            ]}
          />
        </List.Item>
      )}
    />
  );
};

export default AssociatedDoctorsList;